import { createAction, props } from '@ngrx/store';

export const ENTITY_LIST_PAGE_ENTITY_EXPANDED = createAction(
  '[EntityListPage] ENTITY_EXPANDED',
  props<{ payload: { url: string; entityId: string } }>()
);

export const ENTITY_LIST_PAGE_ENTITY_COLLAPSED = createAction(
  '[EntityListPage] ENTITY_COLLAPSED',
  props<{ payload: { url: string; entityId: string } }>()
);
